import { createContext } from 'react';
import { MapUnitColorDto, UnitMapConfiguration } from '../../../api/UnitMap';

interface MapContextInterface {
    map: any;
    setMap: (map: any) => void;
    configuration: UnitMapConfiguration;
    setConfiguration: (newConfig: UnitMapConfiguration) => void;
    colors: MapUnitColorDto[];
    allFloors?: Floor[];
    setAllFloors: (floors: Floor[]) => void;
    selectedFloor?: string;
    selectFloor: (selectedFloor: string) => void;
    selectStop: (selectStop: number | undefined) => void;
    selectedStopIndex?: number;
    locationEnabled: boolean;
    setLocationEnabled: (enabled: boolean) => void;
    onMapClick?: (x: number, y: number) => void;
}

export interface Floor {
    name: string;
    value: string;
}

export const MapContext = createContext<MapContextInterface>({} as MapContextInterface);

export interface UnitMapProps {
    apiKey: string;
}

export interface State {
    map: any;
    units: any;
    levels: any;
}



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/UnitMapTypes.ts